import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Dropdown } from 'react-bootstrap';
import { LinkedinShareButton, TwitterShareButton } from 'react-share';
//actions
import { addToReadLaterThread } from '../../../../../../actions/Dashboard/personalBoards/threadsActions';
import { addFavorite } from '../../../../../../actions/userActions';
import { showModal } from '../../../../../../actions/modalsActions';
//comps
import LoginModal from '../../../../../Modals/LoginModal/LoginModal';
import FeatureLockedModal from '../../newsSection/filters/FeatureLockedModal';
//icons
import { Icon } from '@iconify/react';
import bxDotsVerticalRounded from '@iconify-icons/bx/bx-dots-vertical-rounded';
import bxlTwitter from '@iconify-icons/bx/bxl-twitter';
import bxlLinkedinSquare from '@iconify-icons/bx/bxl-linkedin-square';
import baselineChatBubble from '@iconify/icons-ic/baseline-chat-bubble';
import baselineOpenInNew from '@iconify/icons-ic/baseline-open-in-new';
import baselineBookmark from '@iconify/icons-ic/baseline-bookmark';

const TileActionMenu = ({ item }) => {
  //redux store state
  const favoritesArray = useSelector(state => state.favoritesArray);
  const darkMode = useSelector(state => state.darkMode);
  const currentUser = useSelector(state => state.currentUser);
  const dispatch = useDispatch();
  //local state
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showFeatureLockedModal, setShowFeatureLockedModal] = useState(false);

  const itemPageLink = `${process.env.REACT_APP_TRUKNO_BASE_URL}/dashboard/news/${item._id}`;

  const onBookmarkClick = (e) => {
    e.stopPropagation();
    if (currentUser._id) {
      console.log({ item });
      dispatch(addFavorite(item._id));

      if (item.mainCategory === 'Stories' && !favoritesArray.includes(item._id)) {
        dispatch(addToReadLaterThread(item._id));
      }

    } else {
      setShowFeatureLockedModal(true);
    }
  };

  const onSendToMyBoardClick = () => {
    currentUser._id
      ? dispatch(showModal('SEND_TO_PERSONAL_BOARD', { dialogClassName: 'add-details', item, mode: 'addItemFeed' }))
      : setShowFeatureLockedModal(true);
  };

  const getBookmaroIconColor = () => {
    console.log(item._id);
    if (favoritesArray && favoritesArray.includes(item._id)) return '#3799F3';
    return darkMode ? 'white' : '#6E7482';
  };

  return (
    <div>
      <Dropdown className="article-block-top__dropdown-toggle ml-2">
        <Dropdown.Toggle variant="link" id="dropdown-basic">
          <Icon className="pointer" icon={bxDotsVerticalRounded} style={{ fontSize: '22px' }} />
        </Dropdown.Toggle>

        <Dropdown.Menu>
          <div className="share-block-general">
            <ul className="d-flex flex-column">
              <li onClick={onBookmarkClick}>
                <Icon className="share-block__icon" icon={baselineBookmark} style={{ fontSize: '20px' }} hFlip={true} color={favoritesArray.includes(item._id) ? '#3799f3' : 'white'} />
                <span>Bookmark</span>
              </li>

              <li onClick={onSendToMyBoardClick}><Icon className="share-block__icon" icon={baselineChatBubble} style={{ fontSize: '20px' }} hFlip={true} /><span>My board</span></li>

              <li>
                <LinkedinShareButton url={itemPageLink} rel="noreferrer" target="_blank">
                  <Icon className="share-block__icon" icon={bxlLinkedinSquare} style={{ fontSize: '20px' }} />
                  <span>LinkedIn</span>
                </LinkedinShareButton>
              </li>

              <li>
                <TwitterShareButton url={itemPageLink} rel="noreferrer" target="_blank" >
                  <Icon className="share-block__icon" icon={bxlTwitter} style={{ fontSize: '20px' }} />
                  <span>Twitter</span>
                </TwitterShareButton>
              </li>


              {/* <li><a href={item.url1} rel="noreferrer" target="_blank"><Icon className="share-block__icon" icon={baselineOpenInNew} style={{ fontSize: '22px' }} hFlip={false} /><span className="share-block__label">Read Article</span></a></li> */}
              <a href={item.url1} rel="noreferrer" target="_blank"><li><Icon className="share-block__icon" icon={baselineOpenInNew} style={{ fontSize: '22px' }} hFlip={false} /><span>Read Article</span></li></a>
            </ul>
          </div >
        </Dropdown.Menu>
      </Dropdown>
      <LoginModal showLoginModal={showLoginModal} setShowLoginModal={setShowLoginModal} />
      <FeatureLockedModal showFeatureLockedModal={showFeatureLockedModal} setShowFeatureLockedModal={setShowFeatureLockedModal} onLoginClick={() => setShowLoginModal(true)} />
    </div>

  );
};

export default TileActionMenu;
